export enum PanelClientsAddIndividualStepsEnum {
    Individual = 1,
    IdentityDetails,
    Addresses,
    UploadDocuments,
}
